import { primitiveColorTokens, tokens } from '@cellula/react-theme-patient';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	background: #fcfcfc;
	width: 100%;
	height: 100%;
	border-radius: 16px;
	overflow-y: auto;
	z-index: 0;
	padding: 16px;
	margin: 0 auto;

	${tokens.breakpointQuery.medium} {
		margin: ${tokens.spacing.x9} 0;
		min-height: 80vh;
		max-width: 650px;
		box-shadow: ${tokens.elevation.skim};
	}
`;

const Background = styled.div`
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: #fafbfb;
	position: relative;

	--shadow-color: 218deg 19% 71%;
	--shadow-color: 212deg 25% 65%;
	--shadow-elevation-low: 0px 0.3px 0.4px hsl(var(--shadow-color) / 0.16), 0px 0.4px 0.5px -0.8px hsl(var(--shadow-color) / 0.21),
		0px 0.9px 1.1px -1.6px hsl(var(--shadow-color) / 0.26);
	--shadow-elevation-medium: 0px 0.3px 0.4px hsl(var(--shadow-color) / 0.16), 0px 0.9px 1.1px -0.5px hsl(var(--shadow-color) / 0.21),
		0px 2.1px 2.6px -1.1px hsl(var(--shadow-color) / 0.25), 0.1px 4.7px 5.9px -1.6px hsl(var(--shadow-color) / 0.29);
	--shadow-elevation-high: 0px 0.3px 0.4px hsl(var(--shadow-color) / 0.17), 0px 1.7px 2.1px -0.3px hsl(var(--shadow-color) / 0.2),
		0px 3.1px 3.9px -0.5px hsl(var(--shadow-color) / 0.23), 0.1px 5.1px 6.4px -0.8px hsl(var(--shadow-color) / 0.25),
		0.1px 8.1px 10.1px -1.1px hsl(var(--shadow-color) / 0.28), 0.2px 12.8px 16px -1.4px hsl(var(--shadow-color) / 0.3),
		0.3px 19.5px 24.4px -1.6px hsl(var(--shadow-color) / 0.33);

	&::before {
		display: block;
		content: '';
		display: flex;
		position: absolute;
		inset: 0;
		background: linear-gradient(150deg, transparent 26%, ${primitiveColorTokens.primary['300']});
		pointer-events: none;
		z-index: 0;
		opacity: 0.9;
	}

	&.stacked {
		scale: 0.9;
		border-radius: 32px;
		overflow: hidden;
		opacity: 0.5;
	}
`;

interface Props {
	children: React.ReactNode;
}

export function BackgroundOutlet(props: Props) {
	return (
		<Background>
			<Container>{props.children}</Container>
		</Background>
	);
}
